var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DE 1",
    clipPath: "url(#clip0_22029_1186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.434082 9.40146C1.41967 12.0577 3.97648 13.9507 6.97569 13.9507C9.9749 13.9507 12.5317 12.0577 13.5173 9.40146L6.97569 8.79492L0.434082 9.40146Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.97569 0C3.97648 0 1.41967 1.89297 0.434082 4.54924L6.97569 5.15578L13.5173 4.54921C12.5317 1.89297 9.9749 0 6.97569 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.433869 4.54932C0.153488 5.30498 0 6.12231 0 6.97556C0 7.8288 0.153488 8.64613 0.433869 9.4018H13.5171C13.7975 8.64613 13.951 7.8288 13.951 6.97556C13.951 6.12231 13.7975 5.30498 13.5171 4.54932H0.433869Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22029_1186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.951,
    height: 13.951,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeFlag);
export default __webpack_public_path__ + "static/media/DE-flag.f15d1eb2f57a8b6e02016b1f8e019bfc.svg";
export { ForwardRef as ReactComponent };